import React from 'react';
import { Fancybox } from '@fancyapps/ui'; // its in use please dont remove
import '@fancyapps/ui/dist/fancybox.css';
import { GrDocumentVideo, GrDocumentText } from 'react-icons/gr';
import './CreativeCardsPreview.styles.scss';

const CreativeCardsPreview = ({ deliverables }) => {
  return deliverables.length ? (
    <div className="cc_preview mt-2">
      {deliverables && deliverables.map(({ format, creatives, _id, assets }, index)=>(
        <div key={_id || index}
          className="cc_preview_each">
          <div className="d-flex flex-wrap justify-content-between">
            <h4 className="cc_preview_each--title">Creative <span>#{index + 1}</span></h4>
            <ul className="cc_preview_each_basics">
              <li>
                <h6>{format}</h6>
                <p>Task Type</p>
              </li>
              <li>
                <h6>{creatives}</h6>
                <p>No. of posts</p>
              </li>
            </ul>
          </div>
          <div className="cc_preview_each_assets">
            {assets && assets.map(({ filename, name, filetype, mime, url, _id }) =>{
              if (mime === 'image/png' || mime === 'image/jpg' || mime === 'image/jpeg') {
                return (<a
                  key={_id || filename}
                  href={url}
                  data-fancybox={`creativeAsset_`+index}
                  title={filename || name}
                  className="cc_preview_each_assets_each"
                >
                  <img src={url}
                    alt={filename || name} />
                  <span>{filename || name}</span>
                </a>);
              } else if (mime === 'video/mp4') {
                return (<a
                  key={_id || filename}
                  href={url}
                  data-plyr
                  data-fancybox={`creativeAsset_`+index}
                  title={filename || name}
                  className="cc_preview_each_assets_each"
                >
                  <GrDocumentVideo size={30}
                    fill="#888"/>
                  <span>{filename || name}</span>
                </a>);
              } else {
                return (<a
                  key={_id || filename}
                  href={url}
                  download
                  title={`Download ${filename || name}`}
                  className="cc_preview_each_assets_each"
                >
                  <GrDocumentText size={30}
                    fill="#888"/>
                  <span>{filename || name}</span>
                </a>);
              }
            })}
          </div>
        </div>
      ))}
    </div>
  ):(
    <div className="cc_preview mt-2">
      <div className="cc_preview_each py-5">
        <h4 className="cc_preview_each--title text-center mb-0">No creatives added</h4>
      </div>
    </div>
  );
};

export default CreativeCardsPreview;
